import {Component, Inject, OnInit} from '@angular/core';
import {GlobalConstants} from "../../../../common/global-constants";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ToastrService} from "ngx-toastr";
import {DataService} from "../../../../services/data.service";
import {ConfigurationService} from "../../../../services/configuration.service";
import {UrlUtils} from "../../../../utils/url.utils";
import {forkJoin} from "rxjs";
import {Mapping} from "../../../../common/mapping";
import {AuthenticationService} from "../../../../services/authentication.service";
import {validApprover} from "../../../../services/validation.service";
import {CommonUtils} from "../../../../utils/common.utils";

@Component({
  selector: 'app-pad-transit-time',
  templateUrl: './pad-transit-time.component.html',
  styleUrls: ['./pad-transit-time.component.scss']
})

export class PadTransitTimeComponent implements OnInit {

  padTransitTimeURL = GlobalConstants.SUBMIT_PAD_TRANSIT_TIME_REQUEST_ENDPOINT;
  processTransitTimeRequestURL = GlobalConstants.PROCESS_TRANSIT_TIME_REQUEST_ENDPOINT;
  padTransitTimeForm: FormGroup;

  fromCountryCodeOptions: any[];
  transitTimeOptions: any[];
  transitTimeConfigurations: any[];

  padTransitTimeOptions: any[];
  loading = false;

  records: any[];

  uploadBuckets: any;
  countryCodes: any;

  currentComponentKeyPlaceholder = [];
  currentWorkingRecord: any;

  items: any;
  dropDownOptions: any;

  user = {};

  help_messages: any = this.dataService.help_messages;

  get passportEnabledShipmethods(){
    return this.dataService.passportEnabledShipmethods;
  }

  constructor(@Inject('RequestsService') private requestsService,
              private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              @Inject('ConfigurationService') private readonly configurationService: ConfigurationService,
              @Inject('AuthenticationService') private readonly authenticationService: AuthenticationService,
              @Inject('CommonUtils') private readonly commonUtils: CommonUtils,
              public dataService: DataService) {

  }


  ngOnInit() {
    this.user = this.authenticationService.getUserDetails();
    this.padTransitTimeForm = this.formBuilder.group({
      businessUseCase: ['', Validators.required],
      fromCountryCode: ['', Validators.required],
      componentKeyValue: ['', Validators.required],
      componentKeyPlaceholder: [''],
      transitTimeType: ['', Validators.required],
      numberOfHoursToPad: ['', Validators.required]
    });

    this.fromCountryCodeOptions = this.commonUtils.getFromCountryCodes();
    this.transitTimeOptions = this.dataService.transitTimeOptions;
    this.padTransitTimeOptions = this.dataService.padTransitTimeOptions;

    this.items = this.commonUtils.getItemsBasedOnArc();
  }

  get getItems(){
    return this.commonUtils.getItemsBasedOnArc()
  }

  public onFromCountryCodeChange(fromCountryCode: string) {
    this.loading = true;
    this.currentWorkingRecord = {};

    this.padTransitTimeForm.get(GlobalConstants.BUSINESS_USE_CASE).setValue('');
    this.padTransitTimeForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue('')
    this.currentComponentKeyPlaceholder = [];
    this.dataService.getConfigurationRecordsBasedOnFromCountryCode(fromCountryCode).subscribe((data: any[]) => {
      this.loading = false;
      this.records = data[GlobalConstants.TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY];
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }





  public onBusinessUseCaseChange(businessUseCase) {
    this.currentWorkingRecord = this.commonUtils.getCurrentWorkingRecord(businessUseCase);
    this.dropDownOptions = this.commonUtils.getDropDownOptions(this.currentWorkingRecord, this.records);

    this.padTransitTimeForm.get(GlobalConstants.COMPONENT_KEY_PLACE_HOLDER).setValue(this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    this.currentComponentKeyPlaceholder = this.currentWorkingRecord[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER].split(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR);
    this.padTransitTimeForm.setControl(GlobalConstants.COMPONENT_KEY_VALUE, this.getComponentKeyValueFormGroup());

    this.padTransitTimeForm.get(GlobalConstants.TRANSIT_TIME_TYPE).setValue('');
  }

  public getComponentKeyValueFormGroup() {
    let componentKeyPlaceValueFormGroupInput = {};
    for (let componentKey of this.currentComponentKeyPlaceholder) {
      componentKeyPlaceValueFormGroupInput[componentKey] = new FormControl('', Validators.required)
    }
    return this.formBuilder.group(componentKeyPlaceValueFormGroupInput);
  }

  public async submit() {
    // Creating Request Body
    let requestBody = JSON.parse(JSON.stringify(this.padTransitTimeForm.value));
    let uploadBucket = this.commonUtils.getUploadBucket();
    let timestamp = Math.round(Date.now() / 1000);

    requestBody[GlobalConstants.COMPONENT_KEY_VALUE] = this.commonUtils.buildComponentKeyValue(requestBody[GlobalConstants.COMPONENT_KEY_VALUE], requestBody[GlobalConstants.COMPONENT_KEY_PLACE_HOLDER]);
    requestBody[GlobalConstants.BUSINESS_UNIT] = this.currentWorkingRecord[GlobalConstants.BUSINESS_UNIT];
    let componentKeyValue = requestBody[GlobalConstants.COMPONENT_KEY_VALUE].replace(GlobalConstants.COMPONENT_KEY_VALUE_SEPARATOR, GlobalConstants.SLASH);
    let key = GlobalConstants.COMPUTED_KEYWORD + GlobalConstants.SLASH + requestBody[GlobalConstants.BUSINESS_UNIT] + GlobalConstants.SLASH + requestBody[GlobalConstants.FROM_COUNTRY_CODE] + GlobalConstants.SLASH + componentKeyValue + GlobalConstants.SLASH + timestamp;

    requestBody[GlobalConstants.BUCKET] = uploadBucket;
    requestBody[GlobalConstants.KEY] = key;
    requestBody[GlobalConstants.TIME_STAMP] = timestamp;
    requestBody[GlobalConstants.ARC] = this.commonUtils.getArc();
    requestBody[GlobalConstants.CREATED_BY] = this.user[GlobalConstants.ALIAS];
    requestBody[GlobalConstants.LOOK_UP_KEYS] = this.currentWorkingRecord[GlobalConstants.LOOK_UP_KEYS];
    delete requestBody[GlobalConstants.CURRENT_TRANSIT_TIME];
    requestBody[GlobalConstants.METADATA] = JSON.stringify(requestBody);
    console.log(requestBody);

    try {
      this.loading = true;
      const hasPermission = await this.dataService.checkUserPermissions(requestBody);
      this.loading = false;
      if (hasPermission === false){
        this.toastrService.error(GlobalConstants.NO_PERMISSION_MSG, GlobalConstants.TITLE_ERROR);
        return;
      }
    } catch (error) {
      this.loading = false;
      console.error(GlobalConstants.CHECK_USER_PERMISSIONS_ERROR, error)
      this.toastrService.error(GlobalConstants.SOMETHING_WENT_WRONG, GlobalConstants.TITLE_ERROR);
      return;
    }

    // Call backend apis
    this.loading = true;
    this.requestsService.put(this.padTransitTimeURL, requestBody).subscribe(data => {
      // ToDO : Remove this once we launch EMR in EU & JP
      if(this.commonUtils.getRegion() == 'EU' || this.commonUtils.getRegion() == 'JP'){
        console.log("Calling StepFunction with RequestBody {}", requestBody)
        this.requestsService.put(this.processTransitTimeRequestURL, requestBody).subscribe(data => {
          this.loading = false;
          this.toastrService.success(GlobalConstants.REQUEST_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
        }, error => {
          this.loading = false;
          this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
        });
      }else{
        this.loading = false;
        this.toastrService.success(GlobalConstants.REQUEST_SUCCESSFUL, GlobalConstants.TITLE_SUCCESS);
      }
    }, error => {
      this.loading = false;
      this.toastrService.error(error, GlobalConstants.TITLE_ERROR);
    });
  }
}
